<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          md="12"
          lg="4"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-memory"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Smart Safe Units
              </div>
            </template>
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-divider class="mt-3" />
            <v-data-table
              :headers="headers"
              :items="ssunits"
              :search="search"
              :items-per-page="10"
              sort-by="crypto_idnum"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Units</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-on="on"
                      >
                        New Unit
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.crypto_idnum"
                                label="Crypto ID NUmber"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="saveunit"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
        <v-col
          md="12"
          lg="8"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-wrench"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Smart Safe Site Assignment
              </div>
            </template>
            <div
              v-if="sitedetails"
              class="display-2 font-weight-light"
            >
              Site ID: {{ sitedetails.idnum }} Site Key: {{ sitedetails.sitekey }}
            </div>
            <div
              v-if="sitedetails"
              class="display-2 font-weight-light"
            >
              Address: {{ sitedetails.address }}, {{ sitedetails.city }} {{ sitedetails.zipcode }}
            </div>
            <v-divider class="mt-3" />
            <v-card height="100">
              <v-autocomplete
                v-model="currentsite"
                :autocomplete="Date.now()"
                :items="sites"
                color="secondary"
                label="Select Site"
                validate-on-blur
                @change="onChange($event)"
              />
            </v-card>
          </base-material-card>
          <v-card v-if="sitedetails">
            <v-card-title>
              Smart Safes Assigned to this location
              <v-divider
                class="mx-4"
                vertical
              />
              <v-row justify="center">
                <v-dialog
                  v-model="dialogtest"
                  scrollable
                  max-width="800px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      Select Smart Safe Unit
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>Select Unit</v-card-title>
                    <v-divider />
                    <v-card-text>
                      <v-card min-width="600">
                        <v-autocomplete
                          v-model="dialogtest1"
                          :autocomplete="Date.now()"
                          :items="getallunits"
                          color="secondary"
                          label="Select Safe ID"
                          return-object
                          validate-on-blur
                          item-text="crypto_idnum"
                        />
                      </v-card>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogtest = false"
                      >
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="addtositeprofile_radio"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-card-title>

            <v-row>
              <v-col
                v-for="(profile, idx) in siteunitsprofile"
                :key="idx"
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <base-material-stats-card
                  class="elevation-6"
                  color="info"
                  icon="mdi-safe-square-outline"
                  title="Unit Crypto ID"
                  :value="profile.crypto_idnum"
                />

                <v-btn
                  large
                  outlined
                  class="ma-2"
                  color="red"
                  @click="removeUnit(idx)"
                >
                  <v-icon
                    left
                    large
                    color="red"
                  >
                    mdi-delete-forever
                  </v-icon>
                  Remove Unit
                </v-btn>
                <div class="text-center display-1 font-weight-dark mb-6">
                  You must save any changes to make them permanent.
                </div>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                color="success"
                dark
                class="mb-0"
                @click="save()"
              >
                Save
              </v-btn>
              <v-btn
                color="blue-grey"
                dark
                class="mb-0"
                @click="clearprofile()"
              >
                Clear
              </v-btn>
            </v-card-actions>
          </v-card>

          <base-material-card
            v-if="!loading"
            color="warning"
            icon="mdi-nuke"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Smart Safe Financial Data Reset
              </div>
            </template>
            <div
              v-if="sitedetails"
              class="display-2 font-weight-light"
            >
              Site ID: {{ sitedetails.idnum }}  Version: {{ sitedetails.version }}
            </div>
            <div
              v-if="sitedetails"
              class="display-2 font-weight-light"
            />
            <v-divider class="mt-3" />
            <v-card height="100">
              <v-autocomplete
                v-model="resetsitedetails"
                :autocomplete="Date.now()"
                :items="getlocs"
                color="secondary"
                label="Select Safe"
                validate-on-blur
                @change="onResetChange($event)"
              />
              <v-select
                v-model="resetsitedetails"
                color="primary"
                :items="getlocs"
                outlined
                label="Select Safe"
                @change="onResetChange($event)"
              />
            </v-card>
          </base-material-card>
          <v-card v-if="sitedetails">
            <v-card-title>
              Smart Safe {{ sitedetails.safeid }}
              <br>Assigned to this location {{ sitedetails.idnum }}<br>Status: {{ sitedetails.status }}
              <v-card-text>
                <v-btn
                  color="error"
                  @click="resetsafefinancial(sitedetails.safeid,sitedetails.idnum)"
                >
                  RESET ALL DATA
                </v-btn>
                <div>
                  This will remove all transactions stored in the database from this safe.
                </div>
              </v-card-text>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    components: {
    },
    data: () => ({
      loading: false,
      snackbar: false,
      site_safe_id: '',
      dialogtest1: '',
      dialogtest: false,
      timeout: 5000,
      alertmessage: '',
      fav: true,
      currentsite: '',
      menubuy: false,
      menusell: false,
      message: false,
      dialogm1: '',
      dialog: false,
      search: '',
      chips: [],
      profiles: [],
      sites: [],
      tokens: [],
      clientbuyprofiles: [],
      siteunitsprofile: [],
      clientsellprofiles: [],
      sitedetails: '',
      resetsitedetails: '',
      loadedprofiles: [],
      ssunits: [],
      editedIndex: -1,
      editedItem: {
        crypto_idnum: '',
        assigned: false,
      },
      defaultItem: {
        crypto_idnum: '',
        assigned: false,
      },
      headers: [
        {
          text: 'Unit Crypto ID',
          align: 'center',
          sortable: false,
          value: 'crypto_idnum',
        },
        { text: 'Actions', align: 'center', value: 'action', sortable: false },
      ],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Unit' : 'Edit Unit'
      },
      getallunits () {
        return this.$store.getters.ssunits
      },
      getunassignedunits () {
        // get a list of profiles which are sites with safes assigned to them
        // get a list of all safe ids
        // return the list of unassigned safes
        let siteprofiles = this.$store.getters.loadedSiteProfiles
        let totalunits = this.$store.getters.ssunits
        let assignedsafes = []
        let sitenames = Object.keys(siteprofiles)
        for (let site of sitenames) {
          // console.log(site)
          if (siteprofiles[site].siteunitsprofile) {
            // console.log(siteprofiles[site].siteunitsprofile[0].crypto_idnum)
            if (siteprofiles[site].siteunitsprofile[0]) {
              assignedsafes.push(siteprofiles[site].siteunitsprofile[0].crypto_idnum)
            }
          }
        }
        let unassigned = totalunits.filter(unitrec => {
          if (!assignedsafes.includes(unitrec.crypto_idnum)) {
            return unitrec
          }
        })
        return unassigned
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid
            let prof = Object.values(value.siteunitsprofile)[0]
            if (prof) {
              safeid = prof.crypto_idnum
            }

            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug('today is ', today, ' Todays events ', todaysevents)
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }
            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let version = 'unkown'
            let lastcoms = 'NA'
            if (rec && rec.heartbeat) {
              lastcoms = moment(rec.heartbeat).format('YYYY-MM-DD HH:mm:ss')
            }
            if (rec && rec.version) {
              version = rec.version
            }
            let status = 'N/A'
            if (rec) {
              let now = Date.now()
              let delta = (now - rec.heartbeat)
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (delta <= 3600000) {
                status = 'Online'
              }
              if (delta >= 3600000) { // 60  minutes
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              safeid: safeid,
              status: status,
              rejcount: rejcount,
              sitename: name,
              version: version,
              lastcoms: lastcoms
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        this.reportingsafes = this.locations.map(element => element.safeid)
        this.$log.debug('reporting map ', this.reportingsafes)
        return this.reportingsafes
      },
      getsitedetails () {
        this.$log.debug('current site ', this.currentsite)
        return this.currentsite
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.tokens = this.$store.getters.ssunits
      this.sites = [...new Set(this.$store.getters.loadedSites.map(data => data.idnum))]
      this.$log.debug('sites loaded here are ', this.sites)
      this.loadedprofiles = this.$store.getters.loadedSiteProfiles
      this.profiles = this.$store.getters.ssunits
      this.ssunits = this.$store.getters.ssunits
    },
    methods: {
      resetsafefinancial (crypto_idnum, idnum) {
        this.$log.debug('details to reset ', crypto_idnum, idnum)
        let rec = {
          safeid: crypto_idnum,
          siteidnum: idnum
        }
        this.alertmessage = 'Safe ' + crypto_idnum + ' was unassigned and all data was removed'
        this.snackbar = true
        this.$store.dispatch('resetfinancialdata', rec)
        this.$store.dispatch('loadunits')
        this.$store.dispatch('loadsiteProfiles')
        this.$store.dispatch('loadUserGroups')
        this.$store.dispatch('loadSiteConfigs')
        this.sitedetails = ''
      },
      editItem (item) {
        this.editedIndex = this.ssunits.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        const index = this.ssunits.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') && this.ssunits.splice(index, 1)) {
          this.$store.dispatch('removesmartsafeunit', item.unitkey)
        }
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      saveunkown () {
        let unit = {
          crypto_idnum: this.editedItem.crypto_idnum,
          assigned: this.editedItem.assigned,
          sitekey: this.editedItem.sitekey,
        }
        if (this.editedIndex > -1) {
          // do nothing as I wont allow a user to edit this, only delete it, maybe not even delete.
          Object.assign(this.ssunits[this.editedIndex], this.editedItem)
        } else {
          this.$store.dispatch('createsmartsafeunit', unit)

          this.ssunits.push(this.editedItem)
        }
        this.close()
      },
      removeUnit (token) {
        this.$log.debug('REMOVEING SAFE UNIT')
        let numelements = 1
        this.siteunitsprofile.splice(token, numelements)
        this.$log.debug('get out of here', token)
      },
      onResetChange (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug('loaded sites ', this.$store.getters.loadedSites)
        this.sitedetails = this.locations.find(site => site.safeid === value)
      },
      onChange (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug('loaded sites ', this.$store.getters.loadedSites)
        let site = this.$store.getters.loadedSites.filter(function (site) {
          return site.idnum === value
        })
        this.sitedetails = site[0]
        this.$log.debug('change to site ', this.sitedetails)
        let idnum = this.sitedetails.idnum
        // lets find that sites profile from the ones we loaded and show the tokens they want to offer clients to buy and sell
        if (this.loadedprofiles[idnum].siteunitsprofile) {
          this.siteunitsprofile = this.loadedprofiles[idnum].siteunitsprofile
        }
      },
      addtositeprofile_radio () {
        // only 1 safe at a time
        this.dialogtest = false
        if (this.dialogtest1) {
          this.siteunitsprofile = []
          this.siteunitsprofile.push(this.dialogtest1)
        }
      },
      addtositeprofile (profile) {
        // only 1 safe at a time
        this.dialogtest = false
        if (this.dialogtest1) {
          this.siteunitsprofile = []
          this.siteunitsprofile.push(profile)
        }
      },
      initialize () {
        this.tokens = [
          { tokenname: '', symbol: 'BTC', exchange: 'krakken' }
        ]
      },
      clearprofile () {
        this.siteunitsprofile = []
      },
      saveunit () {
        this.$log.debug(' can we save this ? ', this.editedItem.crypto_idnum)
        this.editedItem.crypto_idnum = this.editedItem.crypto_idnum.trim()
        this.editedItem.crypto_idnum = this.editedItem.crypto_idnum.replace(/\t/g, '')
        if (this.editedItem.crypto_idnum === '') {
          this.alertmessage = 'Spaces # . $ are not allowed in a unit name'
          this.snackbar = true
          this.close()
          return
        }
        // check unallowed chars?
        let notallowedchars = ''
        notallowedchars = this.editedItem.crypto_idnum.match(/\\t|[ #\$\.]/gi)
        this.$log.debug('notallowedchars ', notallowedchars)
        if (notallowedchars) {
          this.alertmessage = 'Spaces # . $ are not allowed in a unit name'
          this.snackbar = true
          this.close()
          return
        }
        this.$log.debug(' UNITS ARE ', this.$store.getters.ssunits, 'our safe is ', this.editedItem.crypto_idnum)

        if (this.$store.getters.ssunits.find(element => element.crypto_idnum === this.editedItem.crypto_idnum)) {
          this.alertmessage = 'This unit is already present'
          this.snackbar = true
          this.close()
          return
        }
        this.$log.debug('NOT ALLOWED !! ', notallowedchars)

        let unit = {
          crypto_idnum: this.editedItem.crypto_idnum,
          assigned: this.editedItem.assigned,
          sitekey: this.editedItem.sitekey
        }
        if (this.editedIndex > -1) {
          // do nothing as I wont allow a user to edit this, only delete it, maybe not even delete.
          Object.assign(this.ssunits[this.editedIndex], this.editedItem)
        } else {
          this.$store.dispatch('createsmartsafeunit', unit)

          this.ssunits.push(this.editedItem)
        }
        this.$store.dispatch('loadunits')
        this.close()
      },
      save () {
        if (this.sitedetails.length === 0) {
          this.alertmessage = 'No site loaded. Please select a site from the drop down menu'
          this.snackbar = true
          return
        }
        const siteprofile = {
          idnum: this.sitedetails.idnum,
          group: this.sitedetails.group,
          sitekey: this.sitedetails.sitekey,
          siteunitsprofile: this.siteunitsprofile,
        }
        this.$store.dispatch('createsiteProfile', siteprofile)
        this.$store.dispatch('loadsiteProfiles')
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.alertmessage = 'Site profile changes saved'
        this.snackbar = true
      }
    }
  }
</script>
